function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "23.408",
  cy: "23.363",
  r: "23.049",
  fill: "#FCE400",
  fillOpacity: ".945"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_103_18)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.86 33.677v-10.49h3.672l.551-4.09H24.86v-2.611c0-1.184.342-1.99 2.115-1.99l2.258-.001v-3.658c-.39-.049-1.73-.16-3.29-.16-3.258 0-5.488 1.905-5.488 5.404v3.016H16.77v4.09h3.684v10.49h4.405z",
  fill: "#2600A1"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_103_18"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(11 10.677)",
  d: "M0 0h24v23H0z"
}))));